import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  style: {"width":"100%","height":"100%"},
  class: "px-16px pt-16px pb-16px"
}
const _hoisted_2 = { class: "search flex items-center gap-4px mb-[16px]" }
const _hoisted_3 = { class: "home" }
const _hoisted_4 = {
  key: 0,
  class: "menu-list grid grid-cols-4 gap-12px",
  style: {"gap":"12px"}
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 1,
  class: "menu-list grid grid-cols-4 gap-12px",
  style: {"gap":"12px"}
}
const _hoisted_7 = { class: "collection mb-[32px]" }
const _hoisted_8 = {
  key: 0,
  class: "title flex items-center justify-between mt-[32px] mb-[16px]"
}
const _hoisted_9 = { key: 2 }
const _hoisted_10 = {
  key: 0,
  class: "element-list h-[calc(100%-40px)]"
}
const _hoisted_11 = {
  key: 1,
  class: "collectList h-[calc(100%-40px)]"
}
const _hoisted_12 = {
  key: 2,
  class: "search h-[calc(100%-40px)]"
}

import { onMounted, ref, nextTick } from 'vue'
import { ElInput, ElButton, ElCascader, ElSkeleton, ElSkeletonItem, ElEmpty } from 'element-plus'
import { ArrowDown, Search } from '@element-plus/icons-vue'
import { getVectorCategory, getCategories, recommendations, } from '@/api/affairs'
// @ts-ignore
// @ts-ignore
import recommendSection from './recommendSection.vue'
// @ts-ignore
import elementlist from './elementlist.vue'
// @ts-ignore
import collectList from './collectList.vue'
// @ts-ignore
import collect from './collect.vue'
// @ts-ignore
import search from './search.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'material',
  setup(__props) {

const menuList = ref([])
const loadingMenu = ref(true)
const recommendList = ref([])
const searchRef = ref<search>()
const searchValue = ref('')
const handleSearch = () => {
  if (searchValue.value.trim() === '') {
    searchShow.value = false
    return
  }
  searchShow.value = true
  elementListShow.value = false
  collectListShow.value = false

  nextTick(() => {
    searchRef.value?.searchList(searchValue.value)
  })
}
const elementListShow = ref(false)
const collectListShow = ref(false)
const searchShow = ref(false)
const categoriesShow = ref(true)

const List = ref([])
const collectNum = ref(0)
const recommendNum=ref(0)
const elementType = ref('')
const handleNum = (num, type) => {
  if (type == 'collect') {
    collectNum.value = num
  }
  if (type == 'recommend') {
    recommendNum.value = num
  }
}
onMounted(() => {
  getVectorCategory({ page: 1, size: 10 }).then(res => {
    menuList.value = res.data.data.items
  }).finally(() => {
    loadingMenu.value = false
  })
  getList()
})
const categoryopt = ref({})
const handleCategoryClick = (item) => {
  categoryopt.value = item
  categoriesShow.value = true
  elementListShow.value = true
  elementType.value = 'svg'
  console.log(item)
}
const getList = () => {

}
const handleMoreClick = (item, type) => {
  categoriesShow.value = false
  elementListShow.value = true
  elementType.value = type
  console.log(item)
  categoryopt.value = item
}
const getimage = (val) => {
  return val.slice(0, 3)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(ElInput), {
        modelValue: searchValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchValue).value = $event)),
        placeholder: "请输入搜索内容",
        clearable: "",
        "prefix-icon": _unref(Search),
        style: {"margin-right":"16px"},
        onClear: _cache[1] || (_cache[1] = ($event: any) => (searchShow.value = false))
      }, null, 8, ["modelValue", "prefix-icon"]),
      _createVNode(_unref(ElButton), {
        type: "primary",
        onClick: handleSearch,
        style: {"background-color":"#2a66ff"}
      }, {
        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
          _createTextVNode("搜索", -1)
        ]))]),
        _: 1
      })
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      (!loadingMenu.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                onClick: ($event: any) => (handleCategoryClick(item)),
                class: "menu-item",
                style: _normalizeStyle({
          'backgroundImage': `url(${item.preview_url})`
        })
              }, null, 12, _hoisted_5))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (n) => {
              return _createElementVNode("div", {
                key: n,
                class: "menu-item"
              }, [
                _createVNode(_unref(ElSkeleton), { animated: "" }, {
                  template: _withCtx(() => [
                    _createVNode(_unref(ElSkeletonItem), {
                      variant: "rect",
                      class: "skeleton-card"
                    })
                  ]),
                  _: 1
                })
              ])
            }), 64))
          ])),
      _createElementVNode("div", _hoisted_7, [
        (collectNum.value > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "text-ellipsis whitespace-nowrap overflow-hidden font-bold" }, "合集", -1)),
              _createElementVNode("div", {
                class: "more cursor-pointer",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (collectListShow.value = true))
              }, " 更多")
            ]))
          : _createCommentVNode("", true),
        _createVNode(collectList, {
          showNum: 4,
          onSelectMore: _cache[3] || (_cache[3] = ($event: any) => (handleMoreClick($event, 'collect'))),
          onNum: _cache[4] || (_cache[4] = ($event: any) => (handleNum($event, 'collect')))
        })
      ]),
      _createVNode(recommendSection, {
        onMore: _cache[5] || (_cache[5] = ($event: any) => (handleMoreClick($event, 'materials'))),
        onNum: _cache[6] || (_cache[6] = ($event: any) => (handleNum($event, 'recommend')))
      }),
      (menuList.value.length == 0&& collectNum.value == 0&&recommendNum.value==0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_unref(ElEmpty), { description: "暂无数据" })
          ]))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, elementListShow.value == false && collectListShow.value == false && searchShow.value == false]
    ]),
    (elementListShow.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(elementlist, {
            categoriesShow: categoriesShow.value,
            onBack: _cache[7] || (_cache[7] = ($event: any) => (elementListShow.value = false)),
            category: categoryopt.value,
            type: elementType.value
          }, null, 8, ["categoriesShow", "category", "type"])
        ]))
      : _createCommentVNode("", true),
    (collectListShow.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(collect, {
            onBack: _cache[8] || (_cache[8] = ($event: any) => (collectListShow.value = false))
          })
        ]))
      : _createCommentVNode("", true),
    (searchShow.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createVNode(search, {
            onBack: _cache[9] || (_cache[9] = ($event: any) => (searchShow.value = false)),
            ref_key: "searchRef",
            ref: searchRef
          }, null, 512)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})